import './iframes.scss'
import {Modal, ResponsiveEmbed} from 'react-bootstrap-v5'

interface Props {
    onClose: () => void
    isOpenCreate: boolean
    link: string
    title: string
}

export function ShowDocumentModal({onClose, isOpenCreate, link, title}: Props) {
    return (
        <Modal
            onHide={() => onClose()}
            show={isOpenCreate}
            size='xl'
            aria-labelledby='contained-modal-title-center'
            centered
            fullscreen={'xl-down'}
        >
            <Modal.Body>
                <ResponsiveEmbed aspectRatio='21by9' className='hideHeader min-h-80'>
                    <embed className='w-100 h-1000px' title='Políticas de Privacidade' src={link} />
                </ResponsiveEmbed>
            </Modal.Body>
        </Modal>
    )
}
